import { render } from "./Cierres.vue?vue&type=template&id=8e23b01e&scoped=true"
import script from "./Cierres.vue?vue&type=script&lang=js"
export * from "./Cierres.vue?vue&type=script&lang=js"

import "./Cierres.vue?vue&type=style&index=0&id=8e23b01e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e23b01e"]])

export default __exports__